require('../../../../_lib/jquery.passwordRequirements');

$(() => {
  const form = $('form[name="accountDetail"]');
  $('.pr-password').passwordRequirements();

  $.post('/account/create-user');

  $('button[type=submit]').click(function (e) {
    e.preventDefault();

    const formData = form.serializeJson();

    $(this).loading();
    $.post('/account/create-account', formData).success(() => {
      window.location = `/account/verification/${formData.email}`;
    }).always(() => {
      if (typeof grecaptcha !== 'undefined') {
        grecaptcha.reset();
      }
      
      $(this).loading('reset');
    });
  });
});
